import React from 'react'
import { useTranslation } from 'react-i18next'

import AuthLoginButton from 'components/Auth/AuthLoginButton/AuthLoginButton'
import AuthLogoutButton from 'components/Auth/AuthLogoutButton/AuthLogoutButton'
import { getOrCreateLoginState } from 'components/Auth/Auth'

import './auth-login-confirm.pcss'

const AuthLoginConfirm = ({ auth }) => {
    const { t } = useTranslation(['common', 'authTos'])

    return (
        <div className="auth-login-confirm">
            <div className="auth-login-confirm__content">
                <p>{t('authTos:loginConfirmModal.text1')}</p>
                <b>{auth.userEmail}</b>
            </div>
            <div className="auth-login-confirm__action">
                <AuthLoginButton
                    email={auth.userEmail}
                    className="button"
                >
                    {t('common:continue')}
                </AuthLoginButton>

                <AuthLogoutButton
                    className="button button--plain"
                    successTarget={getOrCreateLoginState()?.successTarget}
                >
                    {t('common:signOut')}
                </AuthLogoutButton>
            </div>
        </div>
    )
}

export default AuthLoginConfirm
